/**
 * React Query keys for HR employees. Kept in a separate file so the hook module
 * can use Fast Refresh (only hook/component exports).
 */
export const EMPLOYEES_QUERY_KEY = ['hr', 'employees'];
export const EMPLOYEE_DETAIL_QUERY_KEY = (id) => ['hr', 'employees', 'detail', id];
